import { createBrowserRouter, Navigate } from "react-router";
import * as Sentry from "@sentry/react";
import { RootErrorBoundary } from "@/routes/root-error-boundary";
import Root from "@/routes/root";
import { baseDataRoutes } from "@/routes/base-data/base-data-routes";
import BaseDataRoute from "@/routes/base-data/base-data-route";
import { customersRoutes } from "@/routes/customers/customers-routes";
import { CustomersRoute } from "@/routes/customers/customers-route";
import { DashboardRoute } from "@/routes/dashboard/dashboard-route";
import { processesRoutes } from "@/routes/processes/processes-routes";
import { ProcessesRoute } from "@/routes/processes/processes-route";
import { CommitmentsRoute } from "@/routes/commitments/commitments-route";
import { InvoicesRoute } from "@/routes/invoices/invoices-route";
import { invoicesRoutes } from "./invoices/invoices-routes";
import { SearchRoute } from "@/routes/search/search-route";

// See Sentry documentation for more information:
// https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/#usage-with-createbrowserrouter-or-creatememoryrouter
const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" replace />,
      },
      {
        path: "base-data",
        element: <BaseDataRoute />,
        children: baseDataRoutes,
      },
      {
        path: "commitments",
        element: <CommitmentsRoute />,
      },
      {
        path: "customers",
        element: <CustomersRoute />,
        children: customersRoutes,
      },
      {
        path: "dashboard",
        element: <DashboardRoute />,
      },
      {
        path: "invoices",
        element: <InvoicesRoute />,
        children: invoicesRoutes,
      },
      {
        path: "processes",
        element: <ProcessesRoute />,
        children: processesRoutes,
      },
      {
        path: "search",
        element: <SearchRoute />,
      },
    ],
    errorElement: <RootErrorBoundary />,
  },
]);

export default router;
